// @flow

import { CALL_API } from 'constants/common';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } from 'constants/auth';

type LoginBody = {
  username: string,
  password: string
};

export const login = (body: LoginBody) => ({
  [CALL_API]: {
    types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
    endpoint: '/auth-users/login',
    method: 'POST',
    body
  }
});

export type LoginFn = typeof login;

export default null;



// WEBPACK FOOTER //
// ./src/actions/auth.js